<template>
  <span>
  <div class="ep-alert"  v-if="type=='info'">
    <span class="ep-con-img"><img src="../static/loading.png" alt=""></span><span class="ep-con-txt  ep-blue"><slot></slot></span>
  </div>
  <div class="ep-alert"  v-if="type=='success'">
    <span class="ep-con-img"><img src="../static/pass.png" alt=""></span><span class="ep-con-txt  ep-green"><slot></slot></span>
  </div>
  <div class="ep-alert"  v-if="type=='error'">
    <span class="ep-con-img"><img src="../static/prompt.png" alt=""></span><span class="ep-con-txt  ep-red"><slot></slot></span>
  </div>
  </span>
</template>

<script>
  export default {
    name: 'ep-alert',
    props: {
      type: {
        type: String,
        default: 'info'
      }
    }
  }

</script>

<style lang="css" scoped>
  .ep-alert {
    text-align: left;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    display: inline-block;
    position: relative;
    overflow: hidden;
    font-size: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ep-con-img {
    margin-right: 10px;
    position: relative;
    display: inline-block;
    height: 100%;
    vertical-align: top;
  }

  .ep-con-txt {
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    height: 18px;
  }

  .ep-blue {
    color: #2aaae0;
  }

  .ep-green {
    color: #11b841;
  }

  .ep-red{
    color: #e85f5f;
  }

</style>



// WEBPACK FOOTER //
// Alert.vue?bc600ed8